<!--
 * @Description:
 * @Author: liulan
 * @Date: 2021-05-07 10:08:06
 * @LastEditors: wei ze min
 * @LastEditTime: 2021-06-02 10:36:00
 * @FilePath: \code\xingmahui_front\src\views\canEatList\components\ExcellentSelect.vue
 * Copyright (C) 2021 liulan. All rights reserved.
-->
<template>
<!-- 能不能吃精品优选分类组件 -->
  <dl class="recommend_nape" @click.stop="handleRecommendNape(item.id, item.name)">
    <dd>
      <div class="nape_name" v-html="item.name">{{item.name}}
        <!-- <slot name="nape"></slot> -->
      </div>
      <div class="icons">
        <div>
          <div :class="'criteria'+item.preganecy">
            </div>
          <font class="font">备孕</font>
        </div>
        <div>
          <div :class="'criteria'+item.pregnancy">
            </div>
          <font class="font">孕期</font>
        </div>
        <div>
          <div :class="'criteria'+item.confinement">
            </div>
          <font class="font">月子</font>
        </div>
        <div class="icons-doc">
          <div :class="'criteria'+item.lactation">
            </div>
          <font class="font">哺乳</font>
        </div>
        <div>
          <div :class="'criteria'+item.infant">
            </div>
          <font class="font">婴幼儿</font>
        </div>
        <div>
          <div :class="'criteria'+item.nonage">
            </div>
          <font class="font">未成年</font>
        </div>
        <div>
          <div :class="'criteria'+item.middleyounger">
            </div>
          <font class="font">中青年</font>
        </div>
        <div class="icons-doc">
          <div :class="'criteria'+item.quinquagenarian">
            </div>
          <font class="font">老年</font>
        </div>
        
      </div>
    </dd>
    <dt>
      <img v-lazy="item.picture" :key="item.picture" alt="">
    </dt>
  </dl>
</template>

<script>
  export default {
    name: 'ExcellentSelect',
    data() {
      return {}
    },
    props: {
      item: Object
    },
    methods: {
      handleRecommendNape(id, nape) {
        this.$emit('handleRecommendFn', id, nape)
      },
    },
    mounted() {
      console.log(this.item);
    },
  }
</script>

<style lang="less" scoped>
.recommend_nape { // dl
  width: 100%;
  display: flex;
  background: #FFFFFF;
  box-shadow: 0px 0px 6px 0px #EEEEEE;
  border-radius: 8px;
  margin-bottom: 10px;
  padding: 13px 10px 6px;
  box-sizing: border-box;
  align-items: flex-end;
  dt {
    width: 52px;
    height: 52px;
    background: #FFFFFF;
    display: flex;
    justify-content: center;
    // margin: 0 auto;
    // margin-top: 7px;
    text-align: center;
    // box-sizing: border-box;
    border: 1px solid #EEEEEE;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 52px;
      height: 52px;
      display: block;
      object-fit: cover;
      border-radius: 4px;
      overflow: hidden;
    }
  }
  dd {
    width: 100%;
    flex: 1;
    // padding-right: 20px;
    box-sizing: border-box;
    .nape_name {
      width: 100%;
      display: flex;
      flex-direction: column;
      font-size: 16px;
      line-height: 16px;
      font-weight: 600;
      color: #333333;
      .introduction {
        width: 100%;
        background: #FFFFFF;
        display: -webkit-box;
        overflow: hidden;
        word-break: break-all;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        font-size: 12px;
        color: #999999;
        height: 19px;
        line-height: 26px; // 下面icons给margin边距这里得+margin: 7;
        font-weight: 400;
      }
    }
    .icons {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-top: 7px;
      .icons-doc{
        width: 20%;
      }
      >div {
        width: 25%;
        height: 28px;
        padding: 7px 0;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        .font {
          font-size: 14px;
          height: 14px;
          color: #333333;
          line-height: 14px;
        }
        >div {
          width: 14px;
          height: 15px;
          margin:2px 4px 4px 0;
        }
        .criteria0{
          background: url(../../../assets/images/canEat/0.png) no-repeat left / 100%;
        }
        .criteria1{
          background: url(../../../assets/images/canEat/1.png) no-repeat left / 100%;
        }
        .criteria2{
          background: url(../../../assets/images/canEat/2.png) no-repeat left / 100%;
        }
        .criteria3{
          background: url(../../../assets/images/canEat/3.png) no-repeat left / 100%;
        }
        
      }
    }
  }
}
</style>